import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Recipe } from "ceicons";
import { toast } from "react-toastify";
import DifficultyRate from "../../Recipe/DifficultyRate";
import { useTranslation } from "ceco-polyglot";
import DropdownCategories from "../../DropdownCategories";
import { ImageDropzone } from "../../ImageDropzone";
import { isEmpty, map } from "lodash";
import PanelAddTags from "../../PanelAddTags";
import {
  create,
  update,
  labelCreate,
  createPicture,
  updatePicture,
} from "../../../api-relay/Recipes/mutations";
import commitMutation from "../../../api-relay/commitMutation";

import "./recipeModal.scss";

export default function RecipeModal(props) {
  const {
    trigger,
    allCategories,
    allLabel,
    edit = false,
    recipe,
    refetchData,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [file, setFile] = useState();
  const [fileError, setFileError] = useState();
  const [tags, setTags] = useState([]);
  const [tagValue, setTagValue] = useState("");
  const t = useTranslation();

  const actualImageRecipe = formData.mediaFiles?.edges[0]?.node;

  const handleChangeCategory = (e, { value }) => {
    setFormData({
      ...formData,
      category: value,
    });
  };

  const handleChangeHotKeep = (e, { checked }) => {
    setFormData({
      ...formData,
      hotKeep: checked,
    });
  };

  function handleChange(evt) {
    const { value, name } = evt.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  }

  function handleChangeTag(evt) {
    const { value } = evt.target;

    setTagValue(value);
  }

  const onSubmit = async () => {
    let recipeId = formData.id;

    if (validateForm()) {
      let anyError = false;
      const canCommitRecipe = edit
        ? JSON.stringify(recipe) !== JSON.stringify(formData)
        : true;

      const msg = !edit
        ? t("message.recipe_created")
        : t("message.recipe_edited");

      // recipe commit
      if (canCommitRecipe) {
        const variables = formData;
        const mutation = edit ? update : create;

        await commitMutation({ variables, mutation })
          .then((res) => {
            recipeId = edit
              ? res.recipeUpdate.recipe.id
              : res.recipeCreate.recipe.id;
          })
          .catch((e) => {
            anyError = true;

            if (Array.isArray(e)) {
              toast.error(e[0].message);
            } else {
              toast.error(e.errors[0]?.message);
            }
          });
      }

      // label commit
      const formDataLabels =
        edit &&
        map(formData.labels.edges, (labels) => {
          return labels.node;
        });

      const canCommitLabel = edit
        ? JSON.stringify(tags) !== JSON.stringify(formDataLabels)
        : !!tags;

      if (canCommitLabel) {
        const labelsId = map(tags, (tag) => {
          return tag.id;
        });

        const variables = { id: recipeId, labels: labelsId };
        const mutation = labelCreate;

        await commitMutation({ variables, mutation })
          .then((a) => {})
          .catch((e) => {
            anyError = true;

            if (Array.isArray(e)) {
              toast.error(e[0].message);
            } else {
              toast.error(e.errors[0]?.message);
            }
          });
      }

      // añadir imaginen si no tiene

      if (file && !actualImageRecipe) {
        const variables = { id: recipeId };
        const mutation = createPicture;

        await commitMutation({ variables, file, mutation })
          .then((a) => {})
          .catch((e) => {
            anyError = true;

            if (Array.isArray(e)) {
              toast.error(e[0].message);
            } else {
              toast.error(e.errors[0]?.message);
            }
          });
      }

      // cambiar imagen que tiene la receta

      if (file && !!actualImageRecipe) {
        const variables = { id: actualImageRecipe.id, recipe: recipeId };
        const mutation = updatePicture;

        await commitMutation({ variables, file, mutation })
          .then((a) => {})
          .catch((e) => {
            anyError = true;

            if (Array.isArray(e)) {
              toast.error(e[0].message);
            } else {
              toast.error(e.errors[0]?.message);
            }
          });
      }

      if (!anyError && (canCommitRecipe || canCommitLabel || file)) {
        toast.success(msg);
        setModalOpen(false);
        refetchData();
      } else {
        setModalOpen(false);
      }
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.name) errors = { ...errors, name: t("form.errorRequired") };
    if (!formData.category)
      errors = { ...errors, category: t("form.errorRequired") };
    if (!formData.serves)
      errors = { ...errors, serves: t("form.errorRequired") };
    if (!isEmpty(errors)) validate = false;

    setFormErrors(errors);
    return validate;
  };

  const onAddLabel = (label) => {
    setTags((prevState) => [...prevState, label]);

    setTagValue("");
  };

  const onRemove = (label) => {
    let newTags = [];

    map(tags, (tag) => {
      if (label !== tag) {
        newTags.push(tag);
      }
    });

    setTags(newTags);
  };

  return (
    <BasicModal
      size="small"
      className="recipe-modal single-button"
      title={
        <div className="modalTitle">
          <Recipe />
          {edit ? t("modalTitle.editRecipe") : t("modalTitle.createRecipe")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          if (edit) {
            setFormData(recipe);

            setTags(
              map(recipe?.labels.edges, (label) => {
                return label.node;
              })
            );
          } else {
            setFormData({ hotKeep: false, difficulty: "LOW", description: "" });
            setTags([]);
          }

          setFile();
        },
      })}
      actions={
        <Button
          type="submit"
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <Form.Group widths={2}>
          <Form.Field>
            <label>{t("form.addImage")}</label>
            <ImageDropzone
              file={file}
              setFile={setFile}
              fileError={fileError}
              setFileError={setFileError}
              imgLoaded={edit && actualImageRecipe?.mediaUrl}
            />
          </Form.Field>
          <Form.Field>
            <Form.TextArea
              className="form-description"
              defaultValue={formData?.description || ""}
              onChange={handleChange}
              label={t("form.description")}
              name="description"
              maxLength={80}
            />
            {formData?.description?.length || 0}/80
          </Form.Field>
        </Form.Group>
        <Form.Group widths={2}>
          <Form.Input
            name="name"
            error={formErrors && formErrors["name"]}
            defaultValue={formData.name || ""}
            label={t("form.name")}
            placeholder={t("form.name")}
            onChange={handleChange}
            required
          />
          <DropdownCategories
            formData={formData}
            allCategories={allCategories}
            formErrors={formErrors}
            handleChangeCategory={handleChangeCategory}
            required
          />
        </Form.Group>
        <Form.Group widths={2}>
          <Form.Field>
            <label>{t("form.difficult")}</label>
            <DifficultyRate
              onRating={handleChange}
              difficulty={formData.difficulty}
            />
          </Form.Field>
          <Form.Field>
            <Form.Input
              className="form-portion"
              name="serves"
              type="number"
              min={1}
              error={
                formErrors.serves && {
                  content: formErrors["serves"],
                  pointing: "left",
                }
              }
              defaultValue={formData.serves || ""}
              label={t("form.portion")}
              placeholder="00"
              onChange={handleChange}
              transparent
              required
            />
          </Form.Field>
        </Form.Group>
        <Form.Group widths={2}>
          <Form.Checkbox
            toggle
            onChange={handleChangeHotKeep}
            defaultChecked={formData.hotKeep || false}
            label={t("form.keepitwarm")}
            name="hotKeep"
          />
        </Form.Group>
        <Form.Field>
          <label>{`${t("title.labels")}:`}</label>
          <PanelAddTags
            tags={tags}
            allLabel={allLabel}
            onChange={handleChangeTag}
            name="tag"
            value={tagValue}
            onAddLabel={onAddLabel}
            onRemove={onRemove}
          />
        </Form.Field>
      </Form>

      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
